<script lang="ts">
	import { translateFilterName } from '$lib';
	import { getContext } from 'svelte';

	import type { FilterProvider, TermsFilter } from './store.svelte';

	import FilterDrawer from './FilterDrawer.svelte';

	const { filter }: { filter: TermsFilter } = $props();

	const filterProvider = getContext<FilterProvider>('filter');
</script>

{#if filter.values.length === 2}
	{#snippet icon()}
		<span
			class={filterProvider.isChecked(filter.name, 'true')
				? 'icon-[mdi--checkbox-outline]'
				: 'icon-[mdi--checkbox-blank-outline]'}
		></span>
	{/snippet}

	<FilterDrawer
		name={translateFilterName(filter.name)}
		onclick={() => filterProvider.toggleBoolean(filter.name)}
		{icon}
	/>
{/if}
